// extracted by mini-css-extract-plugin
export var table = "_ye-0";